import PeopleIcon from '@mui/icons-material/People';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import PaymentIcon from '@mui/icons-material/Payment';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import DiscountIcon from '@mui/icons-material/Discount';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import CategoryIcon from '@mui/icons-material/Category';
import { ManageAccounts } from '@mui/icons-material';
import FactCheckIcon from '@mui/icons-material/FactCheck';


export const linksInfo = [
    {
        text: "کاربران",
        to: "/users",
        icon: <PeopleIcon sx={{fontSize: "80px"}} />,
        roles: [1, 3]
    },
    {
        text: "پذیرش قطعات",
        to: "/receive-services",
        icon: <AddShoppingCartIcon sx={{fontSize: "80px"}} />,
        roles: [2]
    },
    {
        text: "قطعات من",
        to: "/my-services",
        icon: <MedicalInformationIcon sx={{fontSize: "80px"}} />,
        roles: [2]
    },
    {
        text: "امور مالی",
        to: "/financial",
        icon: <PaymentIcon sx={{fontSize: "80px"}} />,
        roles: [2]
    },
    {
        text: "سرویس‌ها",
        to: "/services",
        icon: <MedicalInformationIcon sx={{fontSize: "80px"}} />,
        roles: [1, 7]
    },
    {
        text: "سفارشات",
        to: "/orders",
        icon: <AddShoppingCartIcon sx={{fontSize: "80px"}} />,
        roles: [1, 4]
    },
    {
        text: "پرداخت‌ها",
        to: "/payments",
        icon: <PaymentIcon sx={{fontSize: "80px"}} />,
        roles: [1]
    },
    {
        text: "تیکت‌ها",
        to: "/tickets",
        icon: <ConfirmationNumberIcon sx={{fontSize: "80px"}} />,
        roles: [1, 3]
    },
    {
        text: "تخفیف‌ها",
        to: "/discounts",
        icon: <DiscountIcon sx={{fontSize: "80px"}} />,
        roles: [1]
    },
    {
        text: "ویژگی‌ها",
        to: "/properties",
        icon: <AppRegistrationIcon sx={{fontSize: "80px"}} />,
        roles: [1]
    },
    {
        text: "مواد اولیه",
        to: "/materials",
        roles: [1],
        icon: <CategoryIcon sx={{fontSize: "80px"}} />,
    },
    {
        text: "مدیریت پیمانکاران",
        to: "/manage-contractor",
        roles: [1, 6],
        icon: <ManageAccounts sx={{fontSize: "80px"}} />,
    },
    {
        text: "کنترل کیفیت",
        to: "/quality-control",
        roles: [1, 7],
        icon: <FactCheckIcon sx={{fontSize: "80px"}} />,
    },
    {
        text: "تسویه پیمانکاران",
        to: "/contractor-settlement",
        roles: [1, 4],
        icon: <PaymentIcon sx={{fontSize: "80px"}} />,
    },
    
]
